import {initFilterSelectLink} from './auctions/filter';

initFilterSelectLink('p_f_1_1', 'p_f_1_1_link', 'Выберите модель');
